module.exports = __webpack_public_path__ + "img/omimg4.ed1d2721.png";